
import { Component, Vue, Watch } from 'vue-property-decorator'
import { Rally } from '../lib/models/Rally'
import { RallyRound } from '../lib/models/RallyRound'

@Component({})
export default class BacRallyRoundDateSubHeader extends Vue {
  logoPath = ''

  get rally (): Rally {
    return this.$store.state.PageURLRally.rally
  }

  get rallyRound (): RallyRound {
    return this.$store.state.PageURLRallyRound.rallyRound
  }

  mounted () {
    if (this.rallyRound) {
      this.setLogoPath()
    }
  }

  @Watch('rallyRound')
  async setLogoPath () {
    this.logoPath = (await import(`@/assets/img/rally/rounds/logos/${this.rallyRound.logo}`)).default
  }
}
